import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/PersonForm.css";

const PersonForm = () => {

  
  const [formData, setFormData] = useState({
    playerImage: "",
    name: "",
    dob: "",
    age: "",
    bloodGroup: "",
    address: "",
    playerOccupation: "",
    parentsOccupation: "",
    yearsOfExperience: "",
    weight: "",
    height: "",
    game: "",
    gender: "",
    fromDate: "",
    toDate: "",
    paymentDate: "",
    alertDate: "",
    alertDays: "",
    totalAmount: "",
  });

  const [persons, setPersons] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState("");
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    fetchPersons();
  }, []);

  const fetchPersons = async () => {
    try {
      const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getPersons");
      setPersons(Object.entries(response.data).map(([key, value]) => ({ id: key, ...value })));
    } catch (error) {
      console.error("Error fetching persons:", error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await axios.put(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/updatePerson/${editId}`, formData);
        setMessage("Person updated successfully!");
      } else {

        await axios.post("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/addPerson", formData);
        setMessage("Person added successfully!");
      }
      setFormData({
        playerImage: "",
        name: "",
        dob: "",
        age: "",
        bloodGroup: "",
        address: "",
        playerOccupation: "",
        parentsOccupation: "",
        yearsOfExperience: "",
        weight: "",
        height: "",
        game: "",
        gender: "",
      });
      setEditMode(false);
      setEditId(null);
      fetchPersons();
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage("Failed to submit form.");
    }
  };

  const handleEdit = (person) => {
    setFormData({
      ...person,
      fromDate: "",
      toDate: "",
      paymentDate: "",
      alertDate: "",
      alertDays: "",
      totalAmount: "",
    });
    setEditMode(true);
    setEditId(person.id);
  };
  

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/deletePerson/${id}`);
      setMessage("Person deleted successfully!");
      fetchPersons();
    } catch (error) {
      console.error("Error deleting person:", error);
      setMessage("Failed to delete person.");
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleExpandRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id]
    );
  };

  

  return (
    <>
    <div className="personformf container">
    <h3 className="p-4 text-center">Add Person List</h3>
      <form className="personform" onSubmit={handleSubmit}>
        
        <div className="row">
          <div className="form-group col-md-6">
            <label>Player Image:</label>
            <input type="text" className="form-control" name="playerImage" value={formData.playerImage} onChange={handleChange} />
          </div>
          <div className="form-group col-md-6">
            <label>Name:*</label>
            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-3">
            <label>DOB:*</label>
            <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} required/>
          </div>
          <div className="form-group col-md-3">
            <label>Age:*</label>
            <input type="number" className="form-control" name="age" value={formData.age} onChange={handleChange} required/>
          </div>
          <div className="form-group col-md-6">
              <label>Gender:*</label>
              <div>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={formData.gender === "Male"}
                    onChange={handleChange}
                    required
                  />{" "}
                  Male
                </label>
                <label className="ml-3">
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    checked={formData.gender === "Female"}
                    onChange={handleChange}
                    required
                  />{" "}
                  Female
                </label>
              </div>
            </div>
        </div>
        
        <div className="row">
          <div className="form-group col-md-4">
            <label>Blood Group:</label>
            <input type="text" className="form-control" name="bloodGroup" value={formData.bloodGroup} onChange={handleChange} />
          </div>
          <div className="form-group col-md-4">
            <label>Weight:</label>
            <input type="number" className="form-control" name="weight" value={formData.weight} onChange={handleChange} />
          </div>
          <div className="form-group col-md-4">
            <label>Height:</label>
            <input type="number" className="form-control" name="height" value={formData.height} onChange={handleChange} />
          </div>
        </div>

        <div className="row">
          
          <div className="form-group col-md-4">
            <label>Game:*</label>
            <select className="form-control" name="game" value={formData.game} onChange={handleChange} required>
              <option value="">Select Game</option>
              <option value="Badmitton">Badmitton</option>
              <option value="Dance">Dance</option>
              <option value="Yoga">Yoga</option>
            </select>
          </div>
          <div className="form-group col-md-4">
            <label>Player Occupation:</label>
            <select className="form-control" name="playerOccupation" value={formData.playerOccupation} onChange={handleChange} required>
              <option value="">Select Occupation</option>
              <option value="Student">Student</option>
              <option value="Professional">Professional</option>
            </select>
          </div>
          <div className="form-group col-md-4">
            <label>Parents Occupation:</label>
            <select className="form-control" name="parentsOccupation" value={formData.parentsOccupation} onChange={handleChange}>
              <option value="">Select Occupation</option>
              <option value="Farmer">Farmer</option>
              <option value="Teacher">Teacher</option>
              <option value="IT">IT Employee</option>
              <option value="Government Job">Government Job</option>
              <option value="others">Others</option>
            </select>
          </div>
        </div>

        <div className="row">
          
        </div>

        <div className="row">
          <div className="form-group col-md-6">
            <label>Years of Experience:</label>
            <input type="number" className="form-control" name="yearsOfExperience" value={formData.yearsOfExperience} onChange={handleChange} />
          </div>
          <div className="form-group col-md-6">
            <label>Address:</label>
            <textarea className="form-control" name="address" value={formData.address} onChange={handleChange}></textarea>
          </div>
        </div>
        <div className="row">
            <div className="form-group col-md-4">
              <label>From Date:*</label>
              <input
                type="date"
                className="form-control"
                name="fromDate"
                value={formData.fromDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-4">
              <label>To Date:*</label>
              <input
                type="date"
                className="form-control"
                name="toDate"
                value={formData.toDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-4">
              <label>Payment Date:*</label>
              <input
                type="date"
                className="form-control"
                name="paymentDate"
                value={formData.paymentDate}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <label>Alert Date:*</label>
              <input
                type="date"
                className="form-control"
                name="alertDate"
                value={formData.alertDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-3">
              <label>Number of Days for Alert:*</label>
              <input
                type="number"
                className="form-control"
                name="alertDays"
                value={formData.alertDays}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group col-md-3">
              <label>Total Amount:*</label>
              <input
                type="number"
                className="form-control"
                name="totalAmount"
                value={formData.totalAmount}
                onChange={handleChange}
                required
              />
            </div>
          </div>

        {message && <p className="success-message">{message}</p>}
        <button type="submit" className="btn mt-3 mb-4 w-25">
          {editMode ? "Update" : "Submit"}
        </button>
      </form>
    
    </div>
    <div className="container1">
      <table className="table table-striped mt-4">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>PersonId</th>
            <th>Player Image</th>
            <th>Name</th>
            <th>DOB</th>
            <th>Age</th>
            <th>Gender</th>
            <th>Blood Group</th>
            <th>Address</th>
            <th>Player Occupation</th>
            <th>Parents Occupation</th>
            <th>Experience</th>
            <th>Weight</th>
            <th>Height</th>
            <th>Game</th>
            <th>Payment Info</th>
            <th>Edit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {persons.map((person, index) => (
            <React.Fragment key={person.id}>
              <tr>
                <td>{index + 1}</td>
                <td>{person.personId || "null"}</td>
                <td>{person.playerImage}</td>
                <td>{person.name}</td>
                <td>{person.dob}</td>
                <td>{person.age}</td>
                <td>{person.gender || "N/A"}</td>
                <td>{person.bloodGroup}</td>
                <td>{person.address}</td>
                <td>{person.playerOccupation}</td>
                <td>{person.parentsOccupation}</td>
                <td>{person.yearsOfExperience}</td>
                <td>{person.weight}</td>
                <td>{person.height}</td>
                <td>{person.game}</td>

                <td>
                  {/* Down Arrow to Expand Row */}
                  <button
                    onClick={() => handleExpandRow(person.id)}
                    className={`btn btn-info btn-sm mt-2 ${expandedRows.includes(person.id) ? "btn-danger" : ""}`}
                  >
                    {expandedRows.includes(person.id) ? "▲" : "▼"}
                  </button>
                </td>

                <td>
                  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(person)}>
                    Edit
                  </button>
                </td>

                <td>
                  <button className="btn btn-danger btn-sm ml-2" onClick={() => handleDelete(person.id)}>
                    Delete
                  </button>
                </td>
              </tr>

              {/* Expanded Row */}
            {/* Expanded Row */}
{expandedRows.includes(person.id) && (
  <tr>
    <td colSpan="16">
      <table className="table mt-3 subtable">
        <thead>
          <tr>
            <th>Actual Id</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Payment Date</th>
            <th>Alert Date</th>
            <th>Alert Days</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {/* Determine the maximum length across all arrays */}
          {Array.from({ length: Math.max(
            person.actualId?.length || 0,
            person.fromDate?.length || 0,
            person.toDate?.length || 0,
            person.paymentDate?.length || 0,
            person.alertDate?.length || 0,
            person.alertDays?.length || 0,
            person.totalAmount?.length || 0
          ) }).map((_, index) => (
            <tr key={index}>
              <td>{person.actualId?.[index] || ''}</td>
              <td>{person.fromDate?.[index] || ''}</td>
              <td>{person.toDate?.[index] || ''}</td>
              <td>{person.paymentDate?.[index] || ''}</td>
              <td>{person.alertDate?.[index] || ''}</td>
              <td>{person.alertDays?.[index] || ''}</td>
              <td>{person.totalAmount?.[index] || ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </td>
  </tr>
)}

            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
    </>
  );
};

export default PersonForm;
